import type { ReactNode } from 'react';

import useLocalization from '../../hooks/useLocalization';
import { useWelcomeBonusAvailability } from '../../hooks/useWelcomeBonus';
import EmptyStateMessage from '../atoms/EmptyStateMessage';
import WelcomeBonusSelection from './WelcomeBonusSelection';

type WelcomeBonusSelectionGateProps = {
  children: ReactNode;
  enabled: boolean;
};

const WelcomeBonusSelectionGate = ({ children, enabled }: WelcomeBonusSelectionGateProps) => {
  const { t } = useLocalization();
  const { data: availability, isError, isLoading } = useWelcomeBonusAvailability(enabled);

  if (!enabled) {
    return <>{children}</>;
  }

  if (isLoading) {
    return null;
  }

  if (!availability) {
    return isError ? <EmptyStateMessage>{t('somethingWentWrong')}</EmptyStateMessage> : null;
  }

  const hasAvailableBonusOption = !!availability.options.sportsbook || !!availability.options.casino;

  if (availability.eligible && !availability.selected && hasAvailableBonusOption) {
    return <WelcomeBonusSelection availability={availability} />;
  }

  return <>{children}</>;
};

export default WelcomeBonusSelectionGate;
